// @ts-nocheck
import React, { Component } from 'react';

// modules
import { COLOR, BLOCK, COUNTRY } from "../../modules/constants"

// mui
import { Box, Tooltip, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'

const styles = theme => ({
  root: {
  },
  dataCard: {
    width: "auto",
    lineHeight: 1,
    padding: `${BLOCK.PADDING_VERT}px 0px ${BLOCK.PADDING_VERT}px 0px`,
    backgroundColor: COLOR.BACKGROUND,
  },
  dataRow: {
    display: "flex",
    flexFlow: "row",
    width: "auto",
  },
  dataItem: {
    flex: 1,
    width: "auto",
  },
  title: {
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: 1,
  },
  dataId: {
    fontSize: 9,
    color: "grey",
    marginTop: 5,
    marginBottom: 2,
    lineHeight: 1,
  },
  dataValue: {
    fontSize: BLOCK.FONT_SIZE,
    fontWeight: "normal",
    lineHeight: 1.1,
  },
  flagIcon: {
    width: 32,
    height: 20,
    border: "solid 1px lightgrey",
  },
})

const iterateDataItems = (classes, dataItems, fontSize) => {
  const rows = []
  let i = 0
  while (dataItems.length > i)
    rows.push(createRow(classes, dataItems[i++], dataItems.length > i ? dataItems[i++] : null, fontSize, i))

  return rows
}

const createRow = (classes, item1, item2, fontSize, key) =>
  <Box key={key} className={classes.dataRow}>
    {createItem(classes, item1, fontSize)}
    {item2 && createItem(classes, item2, fontSize)}
  </Box>

const createItem = (classes, item, fontSize) =>
  <Box id="item.id" className={classes.dataItem}>
    <Typography className={classes.dataId} style={{ fontSize: 9, color: "grey", marginTop: 5, marginBottom: 3, lineHeight: 1 }}>{item.id}</Typography>
    {item.type === "icon" ? imageTag(classes, item) : typographyTag(classes, item, fontSize)}
  </Box>

const typographyTag = (classes, item, fontSize) =>
  <Tooltip arrow title={item.tooltip ?? ""}>
    <Typography className={classes.dataValue} style={{ fontSize, color: item.color, fontWeight: "normal", lineHeight: 1.3 }}>{item.value}</Typography>
  </Tooltip>

const imageTag = (classes, item) =>
  <Tooltip arrow title={COUNTRY[item.value].name}>
    <img className={classes.flagIcon} src={COUNTRY[item.value].flag} alt={COUNTRY[item.value].name} />
  </Tooltip>

class DataCard2xN extends Component {
  render() {
    const { classes, title, dataItems, valueFontSize: fontSize } = this.props

    return (
      <Box id="data-card" className={classes.dataCard}>
        {title && <Typography className={classes.title} >{title}</Typography>}
        {iterateDataItems(classes, dataItems, fontSize)}
      </Box>
    )
  }
}

export default withStyles(styles)(DataCard2xN)

